import PropTypes from 'prop-types';

// material-ui
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// project imports
import nexviaTheme from './nexviaTheme';

export default function ThemeCustomization({ children }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={nexviaTheme}>
        <CssBaseline enableColorScheme />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

ThemeCustomization.propTypes = { children: PropTypes.node };
